import * as React from "react"

import { cn } from "@/lib/utils"

// Density changes only layout; validation remains owned by the caller/FormControl.
const Input = React.forwardRef(({ className, type, density = "standard", ...props }, ref) => {
  const compact = density === "compact"

  return (
    <input
      type={type}
      className={cn(
        "acta-ds-input flex w-full min-w-0 rounded-[10px] border border-input bg-transparent px-3 py-1 text-base text-foreground shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        compact ? "h-9" : "h-10",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
